// extracted by mini-css-extract-plugin
module.exports = {"List":"_1LnDa","ProfitDetails":"_1SL_6","Chart":"E8rPC","ChartBanner":"cs0EB"};